import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stunning%20artistic%20manga%20wallpaper%20with%20warm%20golden%20and%20coral%20tones%2C%20abstract%20comic%20style%20background%2C%20Japanese%20manga%20inspired%20art%2C%20dreamy%20atmosphere%2C%20soft%20gradients%2C%20ink%20splash%20effects%2C%20beautiful%20composition%2C%20clean%20and%20elegant%20design%2C%20warm%20lighting%2C%20professional%20illustration%20quality&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="叮当漫画网 - 无删减漫画免费阅读"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full h-full max-w-7xl mx-auto px-4 md:px-6 flex flex-col lg:flex-row items-center justify-center lg:justify-between">
        <div className="w-full text-center lg:text-left lg:max-w-xl">
          <div className="flex items-center justify-center lg:justify-start gap-1 mb-4">
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-white/80 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cute%20Chinese%20manga%20character%20avatar%20portrait%2C%20warm%20color%20tone%2C%20clean%20manga%20art%20style%2C%20simple%20cream%20background%2C%20friendly%20expression%2C%20professional%20illustration&width=100&height=100&seq=hero-avatar-1&orientation=squarish"
                alt="漫画角色"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-white/80 overflow-hidden -ml-2">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cute%20Chinese%20manga%20character%20avatar%20portrait%2C%20warm%20color%20tone%2C%20clean%20manga%20art%20style%2C%20simple%20cream%20background%2C%20friendly%20expression%2C%20professional%20illustration&width=100&height=100&seq=hero-avatar-2&orientation=squarish"
                alt="漫画角色"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-8 h-8 md:w-10 md:h-10 rounded-full border-2 border-white/80 overflow-hidden -ml-2">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cute%20Chinese%20manga%20character%20avatar%20portrait%2C%20warm%20color%20tone%2C%20clean%20manga%20art%20style%2C%20simple%20cream%20background%2C%20friendly%20expression%2C%20professional%20illustration&width=100&height=100&seq=hero-avatar-3&orientation=squarish"
                alt="漫画角色"
                className="w-full h-full object-cover"
              />
            </div>
            <span className="text-white/80 text-xs md:text-sm ml-3 whitespace-nowrap">360万+ 漫友的选择</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-black text-white leading-tight mb-4">
            <span className="font-black">大黄丫头</span>
            <br />
            <span className="font-light">无删减免费阅读</span>
          </h1>

          <p className="text-white/70 text-sm md:text-base max-w-md mx-auto lg:mx-0 mb-8 leading-relaxed">
            叮当漫画网推出大黄丫头漫画无删减版，下拉式免费阅读，所有内容完整呈现，无需付费，让您畅快追漫。
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
            <Link
              to="/comic/dahuang-yatou"
              className="inline-flex items-center gap-2 px-6 py-3 bg-white text-foreground-900 font-semibold text-sm rounded-full hover:bg-background-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              立即阅读
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/category/all"
              className="inline-flex items-center gap-2 px-6 py-3 border border-white/30 text-white font-medium text-sm rounded-full hover:bg-white/10 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              浏览全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div className="hidden lg:block w-full max-w-md">
          <p className="text-white/60 text-base leading-relaxed text-right">
            每日更新 · 高清画质<br />
            无删减原版 · 下拉畅读<br />
            热血 · 恋爱 · 悬疑 · 奇幻
          </p>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-1 text-white/60 text-xs">
          <span>向下滚动探索</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}